<!-- 地图 -->
<template>
  <div class="centerMapContent">
    <div id="typhoonMap"></div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import * as L from 'leaflet'

// 修复加载默认marker标记图标失败问题
// import monitorTypes from '@/store/types/monitor'
import icon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'
// import config from '@/config'
import request from '@/utils/request'
let DefaultIcon = L.icon({ iconUrl: icon, shadowUrl: iconShadow })
L.Marker.prototype.options.icon = DefaultIcon
require('@/extend/leaflet-extend.js')
require('../../assets/map/leaflet.ChineseTmsProviders.js')
let typhoonImg = require('../../assets/map/images/typhoon.gif')
export default {
  name: 'typhoonMap',
  props: {
    mapWidth: {
      type: String
    },
    mapHeight: {
      style: String
    }
  },
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      typhoonTestData: [],
      typhoonActivity: [],
      allpoints: '',
      count: 0,
      typhoonIcon: '',
      land: '',
      lineLayer: '',
      marker: '',
      polyline: '',
      tfid: '201913'
    }
  },
  // 监听属性 类似于data概念
  computed: {
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    leaflet (typhoonActivity, typhoonTestData) {
      // var normalm = L.tileLayer.chinaProvider('TianDiTu.Normal.Map', {
      //   maxZoom: 18,
      //   minZoom: 0
      // })
      // var normala = L.tileLayer.chinaProvider('TianDiTu.Normal.Annotion', {
      //   maxZoom: 18,
      //   minZoom: 0
      // })
      // var imgm = L.tileLayer.chinaProvider('TianDiTu.Satellite.Map', {
      //   maxZoom: 18,
      //   minZoom: 0
      // })
      // var imga = L.tileLayer.chinaProvider('TianDiTu.Satellite.Annotion', {
      //   maxZoom: 18,
      //   minZoom: 0
      // })
      // var normal = L.layerGroup([normalm, normala])
      // var image = L.layerGroup([imgm, imga])
      // var baseLayers = {
      //   '影像': image,
      //   '地图': normal
      // }
      // var overlayLayers = {}
      // var map = L.map('typhoonMap', {
      //   center: [26.303, 133.67],
      //   zoom: 4,
      //   layers: [image],
      //   zoomControl: false
      // })
      // L.control.layers(baseLayers, overlayLayers).addTo(map)
      // L.control.zoom({
      //   zoomInTitle: '放大',
      //   zoomOutTitle: '缩小'
      // }).addTo(map)
      // // 渲染GeoJson
      // var myStyle = {
      //   'color': '#2dd9f8',
      //   'weight': 3,
      //   'opacity': 1
      // }
      let map = ''
      map = L.CreateTianDiTuMap('typhoonMap', {
        crs: L.CRS.EPSG4490,
        zoomControl: false
      }).setView([26.303, 133.67], 10)
      // L.tileLayer.CustomArcGISServerLayer(
      //   config.ApiYJ + '/files/layers/', // 地图服务地址
      //   {
      //     minZoom: 8, // 最小缩放等级
      //     maxZoom: 21 // 最大缩放等级
      //   }
      // )
      // this.sxMarkers.addTo(map)
      var myStyle = {
        color: '#2dd9f8',
        weight: 3,
        opacity: 1
      }
      // 中国GeoJson数据
      request.get('http://' + window.location.host + '/yjjson/china.json').then(res => {
        L.geoJSON(res.data, {
          style: myStyle
        }).addTo(map)
      })
      this.map = map
      //  数据转换
      var allpoints = this.dataHandler(typhoonTestData)
      // 根据坐标点数组polylinePoints通过 L.polyline 方法 绘制折线，颜色为蓝色blue
      var polyline = L.polyline(allpoints, { color: 'blue' }).addTo(map)
      // polyline.snakeIn()
      map.removeLayer(polyline)
      // line
      var lineLayer
      // Marker
      var marker
      // icon
      var typhoonIcon = L.icon({
        iconUrl: typhoonImg,
        iconSize: [20, 20],
        iconAnchor: [10, 10]
      })
      // 获取台风信息，详细见./data.js文件数据
      var land = typhoonTestData[0]['land'][0]
      this.animateDrawLine(lineLayer, marker, allpoints, land, typhoonIcon, map, typhoonActivity, typhoonTestData)
      this.dataHandler(typhoonTestData)

      /* 动态绘制折线 */
      this.animateDrawLine(lineLayer, marker, allpoints, land, typhoonIcon, map, typhoonActivity, typhoonTestData)
    },
    animateDrawLine (lineLayer, marker, allpoints, land, typhoonIcon, map, typhoonActivity, typhoonTestData) {
      // allpoints 是上边介绍的数据转换的结果
      var allpoinstLength = allpoints.length
      // 定义用来存放递增元素的经纬度数据
      var drawPoints = []
      var count = 0
      // 定时器100ms，动态的塞入坐标数据
      this.timer = setInterval(() => {
        if (count < allpoinstLength) {
          drawPoints.push(allpoints[count])
          count++
          // 清除之前绘制的折线图层
          if (lineLayer && count !== allpoinstLength) {
            map.removeLayer(lineLayer)
            lineLayer = null
          }
          // 清除marker图层
          if (marker && count !== allpoinstLength) {
            map.removeLayer(marker)
            marker = null
          }
          // 最新数据点drawPoints绘制折线
          lineLayer = L.polyline(drawPoints, { color: 'blue' }).addTo(map)

          // 根据最新数组最后一个点绘制marker
          if (count === allpoinstLength) {
            map.removeLayer(marker)
            // 如果是台风最后一个点，则自动popup弹窗
            console.log(typhoonActivity, 111111111111111111111)
            marker = L.marker(drawPoints[allpoinstLength - 1], { icon: typhoonIcon }).addTo(map)
              .bindPopup('<b>' + typhoonActivity[0]['name'] +
                '(' + typhoonActivity[0]['timeformate'] + ')')
              .openPopup()
          } else {
            marker = L.marker(drawPoints[count - 1], { icon: typhoonIcon }).addTo(map)
          }
        }
      }, 100)
    },
    /* 数据转换 & 绘制折线图 */
    // typhoonTestData变量是全局的台风数据对象，详细见./data.js文件
    dataHandler (typhoonTestData) {
      // 获取台风坐标点数据对象
      var forecast = typhoonTestData[0]['points']
      // 定义折线点数据
      var polylinePoints = []
      // 循环拼接数据[[经度，纬度],[经度,纬度]] 的格式
      for (var i = 0; i < forecast.length; i++) {
        var p = forecast[i]
        polylinePoints.push([Number(p['lat']), Number(p['lng'])])
      }
      return polylinePoints
    }
    // getTyphoonActivity () {
    //   this.$store.dispatch(monitorTypes.GET_TYHOON_ACTIVITY, {
    //     tfid: this.tfid
    //   }).then(data => {
    //     this.typhoonActivity = data
    //     this.loading = false
    //     this.getTyphoonInfo(this.typhoonActivity)
    //   })
    // },
    // getTyphoonInfo (typhoonActivity) {
    //   this.$store.dispatch(monitorTypes.GET_TYPHOON_INFO, {
    //     tfid: this.tfid
    //   }).then(data => {
    //     this.typhoonTestData = data
    //     this.loading = false
    //     this.leaflet(typhoonActivity, this.typhoonTestData)
    //   })
    // }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    // this.getTyphoonActivity()
  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () {
    // 取完数据后清楚定时器
    clearInterval(this.timer)
  }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="less" scoped>
.centerMapContent {
  width: 100%;
  height: 555px;
  position: relative;
  #typhoonMap {
    width: 100%;
    height: 1080px;
    position: relative;
  }
}
</style>
